
export const menuItems = [
  {
    id: 1,
    title: 'Anuncios',
    icon: '',
    link: '/trabajos'
  },
  {
    id: 2,
    title: 'Empresas',
    icon: '',
    link: '/empresas'
  },
  {
    id: 3,
    title: 'Nosotros',
    icon: '',
    link: '/nosotros'
  }
]